/**
 * FILE: apps/hub/src/hooks/useTheme.ts
 * PURPOSE: Consume the theme context set up by ThemeProvider.
 */

import { useContext } from 'react'
import { ThemeContext, type ThemeContextValue } from './themeContext'

export function useTheme(): ThemeContextValue {
  const ctx = useContext(ThemeContext)
  if (!ctx) throw new Error('useTheme must be used within a ThemeProvider')
  return ctx
}
